export enum StElementType {
  STTEXTELEMENT = 'stTextElement',
  STIMAGEELEMENT = 'stImageElement',
  STVIDEOELEMENT = 'stVideoElement',
  STGRAPHELEMENT = 'stGraphElement',
  STTABLEELEMENT = 'stTableElement',
}
